export default __webpack_public_path__ + "static/media/correspondent20.85544a80.png";